import React from "react";
import { FavoriteFilledIcon, FavoriteIcon } from "../../Icons/icons.component";

export function FavouriteTag({
  onFavouriteIconClick,
  defaultValue,
}) {
  const onFavouriteClick = (item) => {
    onFavouriteIconClick(item);
  };

  return (
    <>
      {defaultValue &&
        <span className="btn favouriteBtn" onClick={() => onFavouriteClick(false)}>
          <div className="hasTooltip">
            <FavoriteFilledIcon />
            <span className="tooltipWrap center">Unfavourite</span>
          </div>
        </span>
      }
      {!defaultValue &&
        <span className="btn favouriteBtn" onClick={() => onFavouriteClick(true)}>
          <div className="hasTooltip">
            <FavoriteIcon />
            <span className="tooltipWrap center">Favourite</span>
          </div>
        </span>
      }
    </>
  );
}
